export default __webpack_public_path__ + "static/media/notif.a733325b.mp3";